/* @ngInject */
const ownerCtrl = (
  $scope,
  $$owner,
  $$contact
) => {
  $scope.$$owner = $$owner
  $scope.$$contact = $$contact
}

export default ownerCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/owner/owner.controller.js